import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c938bcc3f84800139358f5/netmanager/src/app/chatbot/components/ChatbotContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c938bcc3f84800139358f5/netmanager/src/components/AppLayout.tsx");
